module.exports = __webpack_public_path__ + "static/img/no-components.3bd19c87.svg";